"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../assets/css/font-face.css");

require("./ActionButton.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ActionButton = function ActionButton(_ref) {
  var actions = _ref.actions,
      onClick = _ref.onClick;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var wrapperClass = 'action-button';
  if (visible) wrapperClass += ' action-button--visible';

  var handleClick = function handleClick(action) {
    onClick(action);
    setVisible(false);
  };

  var renderActions = function renderActions() {
    return actions.map(function (_ref2) {
      var action = _ref2.action,
          title = _ref2.title,
          _ref2$danger = _ref2.danger,
          danger = _ref2$danger === void 0 ? false : _ref2$danger;
      var itemClass = 'action-button__item';
      if (danger) itemClass += ' action-button__item--danger';
      return _react.default.createElement("li", {
        className: itemClass,
        onClick: function onClick() {
          return handleClick(action);
        },
        key: action
      }, title);
    });
  };

  return _react.default.createElement("div", {
    className: wrapperClass
  }, _react.default.createElement("span", {
    className: "action-button__icon",
    onClick: function onClick() {
      return setVisible(!visible);
    }
  }, _react.default.createElement("span", null)), _react.default.createElement("ul", {
    className: "action-button__list"
  }, renderActions()));
};

ActionButton.defaultProps = {
  actions: [],
  onClick: function onClick() {}
};
ActionButton.propTypes = {
  /** Array de dados contendo as ações que podem ser realizadas */
  actions: _propTypes.default.array.isRequired,

  /** Função executada após selecionar alguma ação */
  onClick: _propTypes.default.func
};
var _default = ActionButton;
exports.default = _default;